import type { PaymentListItem, PaymentStatusApi } from "../types/payments-api.types";
import type { Payment, PaymentStatus } from "../types/payments.types";

/**
 * Maps API status to UI status used by columns. PENDING → pending, IN_PROGRESS → in_progress, PAID → paid.
 * CANCELLED, ARCHIVED, FILED are not shown on the board (returns null).
 */
function mapApiStatusToPaymentStatus(status: PaymentStatusApi): PaymentStatus | null {
  if (status === "PENDING") return "pending";
  if (status === "IN_PROGRESS") return "in_progress";
  if (status === "PAID") return "paid";
  return null;
}

export function mapPaymentListItemToPayment(item: PaymentListItem): Payment | null {
  const status = mapApiStatusToPaymentStatus(item.status);
  if (status === null) return null;
  const verifiedByAdmin = status === "paid" && item.taken_by_user != null;

  return {
    id: item.id,
    name: item.client_name,
    amount: String(item.amount),
    currency: item.currency,
    status,
    payer: item.payer_name,
    platform: item.bank,
    date: item.created_at,
    createdAt: item.created_at,
    updatedAt: item.updated_at,
    referenceCode: item.reference_code ?? undefined,
    note: item.notes ?? undefined,
    createdBy: item.user?.email,
    updatedByEmail: item.taken_by_user?.email ?? undefined,
    verifiedByAdmin,
    takenById: item.taken_by_user_id ?? null,
    takenByName: item.taken_by_user?.full_name ?? item.taken_by_user?.email ?? null,
    takenAt: item.taken_at ?? null,
    attachmentUrls: (() => {
      const v = item.attachment_url;
      if (v == null) return [];
      return Array.isArray(v) ? v.filter((u): u is string => typeof u === "string") : [v];
    })(),
    urlHas: item.url_has ?? undefined,
    network: item.network ?? (item as { red?: string | null }).red ?? undefined,
    bankMetadata:
      item.bank_metadata != null && typeof item.bank_metadata === "object"
        ? (item.bank_metadata as Record<string, unknown>)
        : undefined,
  };
}
